import React, { useEffect } from 'react'
import Title from 'shared/components/Title'
import { toast } from 'libs/toast'
import constants from 'config/constants'
import * as R from 'ramda'
import { useLocation } from 'react-router-dom'
import { useHistory } from 'react-router'
import useAxios from 'hooks/useAxios'
import store from 'store'
import { convertQueryParamStringToObject } from 'libs/convertQueryParamStringToObject'
import { Loader } from '../../shared/components/Loader'
import { signedInLogCallBack } from 'pages/Login/utils'
import { completeOAuthInOpenerOrNavigate } from 'libs/oauthIframeBridge'

const CompleteLoginJit = () => {
  const { fetch: authCodeTradeAPI, loading: isCompleteLoginJitPageLoading } = useAxios({
    url: 'sso/jit/',
    method: 'post',
    skip: true,
    headers: {
      Authorization: '',
      'X-Workspace-Token': '',
    },
  })
  const location = useLocation()
  const history = useHistory()
  const referer = R.path(['state', 'prev', 'pathname'], location) || '/'

  useEffect(() => {
    const { code } = convertQueryParamStringToObject(location.search)
    const requestPayload = { code }

    if (!code) {
      toast.error('Token has invalid or expired.')
      return history.push('/login')
    }

    authCodeTradeAPI({ data: requestPayload })
      .then((response) => {
        if (response.data.token) {
          // Has token / does require otp -> send user to otp page
          if (response.data.require_otp) {
            history.push({
              pathname: '/login/two-factor/',
              search: location.search + '&logged_in_method=jit',
              state: {
                token: response.data.token,
                pathname: referer,
              },
            })
            // Has token / no require otp -> send user to dashboard
          } else {
            store.set(constants.simplesatTokenName, response.data.token)

            completeOAuthInOpenerOrNavigate(history, {
              pathname: '/',
              state: signedInLogCallBack('jit'),
              token: response.data.token,
            })
          }
        }
      })
      .catch((error) => {
        toast.error(error.message)
        history.push('/login')
      })
  }, [location.search, authCodeTradeAPI, history, referer])

  return (
    <div>{isCompleteLoginJitPageLoading ? <Loader /> : <Title title="Complete JIT login" />}</div>
  )
}

export default CompleteLoginJit



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/CompleteLoginJit/index.js